// bao migrate skip
import * as ko from "knockout";
import Bao from "./bao-service";
import MessageBus, { IMessageBusEventHandler } from "./message-bus";
import baoRouter from "./bao-router";

export interface BaoMenuButton {
    ActionKey: KnockoutObservable<string> | string;
    Enabled: KnockoutObservable<boolean>;
    Visible: KnockoutObservable<boolean>;
}
export interface BaoMenuContainer {
    Caption: KnockoutObservable<string> | string;
}
export interface BaoMenuGroup {
    GroupTitle: KnockoutObservable<string> | string;
}
export interface AvailableLanguage {
    Symbol: KnockoutObservable<string>;
    LanguageIndex: KnockoutObservable<number>;
    Enbled: KnockoutObservable<boolean>;
    Visible: KnockoutObservable<boolean>;
    MethodInfo: KnockoutObservable<string>;
    ToolTip: KnockoutObservable<string>;
}

export class BaoApp {
    public Bao = Bao;
    public TabController = null; // is set by bao-app component
    public AppNameHtml = ko.observable<string>();
    public AppNameWidth = ko.observable<number>(125);
    public horizontalMode = ko.observable(true);
    public activeContextMenu = ko.observable(null);
    public horizontalMenuContainer = ko.observable();
    public MenuVisible = ko.observable(false);
    public contextCollection = ko.observableArray([]);
    public currentListMenu = ko.observableArray([]);
    public currentButtonMenu = ko.observableArray([]);
    public selectedContainer = ko.observable();
    public selectedContext = ko.observable();
    public breadCrumbs = ko.observableArray([]);
    public contextColor = ko.observable();
    public startMenu = ko.observableArray([]);
    public userMenu = ko.observable({ Visible: ko.observable(false), Enabled: ko.observable(true) });
    public contextMenu = ko.observableArray([]);
    public Initialized = ko.observable(false);
    public popUpRight = ko.observable("3px");
    public popUpTop = ko.observable("41px");
    public selectedHorizontalButton = ko.observable();
    public notificationCount = ko.observable(0).extend({ notify: 'always' });
    public notificationIconEnabled = ko.observable(false);
    public taggingsChangedEventHandlers: IMessageBusEventHandler = {
        name: 'notifyUserOnTaggingsChanged',
        handler: (count: number) => this.notificationCount(count)
    };
    private _events = [];
    private _ignoreDocumentClick = false;
    private _lastSelectedHorizontalItem = null;
    constructor() {
        this.horizontalMode.subscribe((newValue) => {
            if (newValue == true) {
                if (this.userMenu() != null) {
                    this.userMenu().Visible(false);
                }
            } else {
                if (this.userMenu() != null) {
                    this.userMenu().Visible(true);
                }
            }
        });
    }
    public addContext = (context) => {
        if (context != null) {
            this.contextCollection.push(context);
        }
    }
    public selectContext = (context) => {
        if (context == null) {
            context = this.contextCollection()[0];
        }
        if (context != null) {
            let contextContainer = null;
            if (context.Container() != null && context.Container()[0] != null) {
                contextContainer = context.Container()[0];
            }
            if (contextContainer != null && contextContainer != this.activeContextMenu()) {
                for (let i = 1; i < this.contextCollection().length; i++) {
                    this.contextCollection()[i].Visible(false);
                }
                context.Visible(true);
                this.contextColor(context.Color());
                this.resetMenu(context);
                this.selectedContext(context);
                this.activeContextMenu(contextContainer);
                this.selectedHorizontalButton(this.startMenu()[0]);
            }
        }
    }
    public breadcrumbClick = (item, e) => {
        this._ignoreDocumentClick = true;
        Bao.Utils.stopPropagation(e);
        this.currentListMenu(item.ListMenu);
        this.currentButtonMenu(item.ButtonMenu);
        this.contextColor(item.Color);
        const newBreadcrumbs = [];
        if (item.Index > 0) {
            for (let i = 0; i <= item.Index; i++) {
                newBreadcrumbs[i] = this.breadCrumbs()[i];
            }
        }
        this.breadCrumbs(newBreadcrumbs);
    }
    public removeContext = (context) => {
        this.contextCollection.remove(context);
        if (this.contextCollection().length > 0) {
            this.selectContext(this.contextCollection()[0]);
        }
    }
    public init = (mainForm = "MainForm", applicationId?) => {
        const def = $.Deferred();
        if (this.Initialized() == true) {
            def.resolve();
        } else {
            this.registryUserOnTaggingsChangedHandler();

            if (mainForm == undefined) {
                mainForm = "MainForm";
            }
            $(document).click((event) => {
                this.MenuVisible(false);
            });
            $(window).resize(() => {
                this.checkHorizontalModelVisibility();
            });
            if (window["Hammer"] != undefined) {
                window["Hammer"](document).on("release", (event) => {
                    this.checkHorizontalModelVisibility();
                });
            }
            this.notificationIconEnabled = Bao.Session.HasPermission("showNotificationIcon", applicationId);
            $.when(this.initMainMenu(mainForm, applicationId), this.initUserMenu(mainForm, applicationId)).then(() => {
                this.Initialized(true);
                this.resetMenu();
                def.resolve();
            });
        }
        return def.promise();
    }

    public initMainMenu(mainForm = "MainForm", applicationId?: string) {
        return Bao.post("Bao/LoadMenu", JSON.stringify({ formName: mainForm, color: "", applicationId: applicationId }), (value) => {
            if (value != null) {
                const newContextArray = [ko.map.fromJS(value)];
                ko.utils.arrayForEach(this.contextCollection(), (item) => {
                    newContextArray[newContextArray.length] = item;
                });
                this.contextCollection(newContextArray);
            }
        });
    }

    public initUserMenu(mainForm = "MainMenu", applicationId?: string) {
        return Bao.post("Bao/LoadUserMenu", JSON.stringify({ formName: mainForm, color: "", applicationId: applicationId }), (value) => {
            if (value != null) {
                value.Visible = !this.horizontalMode();
                this.userMenu(ko.map.fromJS(value));
            }
        });
    }
    public isMenuSelected = (sender): boolean => {
        if (sender.ActionKey() != null && Bao.Session != null && sender.ActionKey().toLocaleLowerCase().indexOf("actionchangetheme") > -1) {
            return Bao.Session.UserSelectedTheme().trim().toLowerCase() === (sender.ActionKey().trim().toLowerCase());

        } else
            if (sender.ActionKey() != null && Bao.Session != null && sender.ActionKey().indexOf("ChangeLanguage") > -1) {
                return Bao.Session.Language.Symbol().trim().toLowerCase() === (sender.Symbol().trim().toLowerCase());

            }

        return false;
    }
    public clickHandler = (sender, event) => {
        this.MenuVisible(false);
        if (sender.Visible() == true && sender.Enabled() == true) {
            if (sender.click != null && typeof sender.click === "function") {
                sender.click();
            } else if (sender.TargetUrl() != null && sender.TargetUrl().startsWith("#")) {
                return true;
            } else {
                if (!Bao.Utils.String.IsNullOrEmpty(sender.TargetUrl())) {
                    const TabPage = window.baorequire("Factories/TabPage");
                    const tabPage = new TabPage();
                    tabPage.Url(sender.TargetUrl());
                    let title = "loading";
                    if (sender.ToolTip != null && sender.ToolTip() != "" && sender.ToolTip() != null) {
                        title = sender.ToolTip();
                    }
                    tabPage.Object = ko.map.toJS(sender);
                    tabPage.Title(title);
                    if (sender.ReflectionType() != null && sender.ReflectionType() != "") {
                        tabPage.ObjectId(sender.ReflectionType());
                    }
                    const TabController = window.baorequire("Services/AppTabController");
                    TabController.AddTab(tabPage);
                }
                this.raiseEvent(sender);
            }
        }
    }
    public registerEvent = (fn) => {
        let found = false;
        for (let i = 0; i < this._events.length; i++) {
            if (fn == this._events[i]) {
                found = true;
                break;
            }
        }
        if (found == false) {
            this._events.push(fn);
        }
        return fn;
    }
    public unregisterEvent = (fn) => {
        for (let i = 0; i < this._events.length; i++) {
            if (fn == this._events[i]) {
                this._events.splice(i, 1);
            }
        }
    }
    public resetMenu = (selectedContext?) => {
        const tempArray = [];
        let contextTabs = [], color;
        for (let i = this.contextCollection().length - 1; i >= 0; i--) {
            const context = this.contextCollection()[i];
            if (context.Visible() == true) {
                ko.utils.arrayForEach(context.Container(), (container: BaoMenuContainer) => {
                    if (this.contextCollection().length > 1 && (i == this.contextCollection().length || context == selectedContext)) {
                        contextTabs[contextTabs.length] = container;
                        color = context.Color();
                    }
                    tempArray[tempArray.length] = { Caption: container.Caption, Item: container, Color: context.Color(), Index: i };
                });
            }
        }
        this.currentListMenu(tempArray);
        this.startMenu(tempArray);
        if (this.horizontalMenuContainer() != null) {
            this.horizontalMode($(this.horizontalMenuContainer()).height() <= $(this.horizontalMenuContainer()).parent().height() + 2);
        }
        if (this.horizontalMode() == false && this.userMenu() != null) {
            const myAccountContainer = { Caption: "Mein Konto", Item: this.userMenu(), Color: null, Index: 0 };
            this.currentListMenu.push(myAccountContainer);
        }
        this.currentButtonMenu([]);
        this.breadCrumbs([]);
        if (contextTabs.length > 0) {
            this.initContextMenu(contextTabs, color, 0);
        }
        this.checkHorizontalModelVisibility();
    }
    public activeContextContainerClicked = (item, e) => {
        if (item.Enabled() == true) {
            const position = $(e.target).closest(".baomenu.activemenu").position();
            let right = $(window).width() - 300 - position.left;
            if (right < 3) {
                right = 3;
            }
            this.popUpRight(right + "px");
            this.popUpTop("88px");
            this.breadCrumbs([]);
            this.containerClicked({ Item: item, Caption: item.Caption }, e);
            if (this._lastSelectedHorizontalItem == item) {
                this.MenuVisible(this.MenuVisible() === false);
            } else {
                this.MenuVisible(true);
            }
            this._lastSelectedHorizontalItem = item;
        }
    }
    public containerClicked = (item, e?) => {
        this._ignoreDocumentClick = true;
        if (e != null) {
            Bao.Utils.stopPropagation(e);
        }
        if (this.breadCrumbs().length == 0) {
            this.breadCrumbs.push({ Caption: "Start", Index: 0, ListMenu: this.currentListMenu(), ButtonMenu: this.currentButtonMenu(), Color: "" });
        }
        if (item.Color != null) {
            this.contextColor(item.Color);
        }
        if (item.Item.Buttons != null) {
            this.currentListMenu([]);
            if (item.Item.ActionKey() === "ChangeLanguage") {
                let languages = this.GetButtonsFromAvailableLanguages();
                this.currentButtonMenu(languages());
            }
            else {
                this.currentButtonMenu(item.Item.Buttons());
            }
        } else {
            this.currentButtonMenu([]);
        }
        const tempArray = [];
        if (item.Item.Groups != null) {
            ko.utils.arrayForEach(item.Item.Groups(), (group: BaoMenuGroup) => {
                tempArray[tempArray.length] = { Caption: group.GroupTitle, Item: group, Color: item.Color, Index: item.Index };
            });
            this.currentListMenu(tempArray);
            this.breadCrumbs.push({ Caption: item.Caption, Index: this.breadCrumbs().length, ListMenu: this.currentListMenu(), ButtonMenu: this.currentButtonMenu(), Color: item.Color });
        } else if (item.Item.Container != null) {
            ko.utils.arrayForEach(item.Item.Container(), (container: BaoMenuContainer) => {
                tempArray[tempArray.length] = { Caption: container.Caption, Item: container, Color: item.Color, Index: item.Index };
            });
            this.currentListMenu(tempArray);
            this.breadCrumbs.push({ Caption: item.Caption, Index: this.breadCrumbs().length, ListMenu: this.currentListMenu(), ButtonMenu: this.currentButtonMenu(), Color: item.Color });
        } else {
            this.breadCrumbs.push({ Caption: item.Caption, Index: this.breadCrumbs().length, ListMenu: null, ButtonMenu: this.currentButtonMenu(), Color: item.Color });
        }
    }
    /***Return the language as the button*/
    private GetButtonsFromAvailableLanguages() {
        let languages = ko.observableArray<any>();
        ko.map.fromJS(this.Bao.Session.AvailableLanguages(), languages)
        languages().forEach((language) => {
            language.Visible = ko.observable(true);
            language.ActionKey = ko.observable("ChangeLanguage");
            language.Enabled = ko.observable(true);
            language.TargetUrl = ko.observable("");
            language.ToolTip = "";
            language.MethodInfo = "";
        });

        return languages;
    }
    public TargetUrlHasValidHref = (targetUrl) => {
        return (targetUrl.startsWith("#") || targetUrl.startsWith("https://") || targetUrl.startsWith("http://"));
    }
    public TargetUrlsTarget = (targetUrl) => {
        if (targetUrl.startsWith("https://") || targetUrl.startsWith("http://")) {
            return "_blank";
        }
        return "_self";
    }
    public ToggleMenu = (vm, e) => {
        this._ignoreDocumentClick = true;
        Bao.Utils.stopPropagation(e);
        this.popUpRight("3px");
        this.popUpTop("45px");
        this.MenuVisible(!this.MenuVisible());
    }
    public ToggleUserMenu = (vm, e) => {
        if (this.userMenu() != null) {
            this.containerClicked({ Caption: "Mein Konto", Item: this.userMenu(), Color: null, Index: 0 }, null);
            this.ToggleMenu(vm, e);
        }
    }
    public horizontalMenuClick = (item, e) => {
        this.selectedHorizontalButton(item);
        this.activeContextMenu(item.Item);
    }
    public initContextMenu = (items, color, rekIndex) => {
        if (rekIndex == null) {
            rekIndex = 0;
        }
        for (let i = 0; i < items.length; i++) {
            if (rekIndex == 0) {
                this.breadCrumbs([]);
            }
            let caption = "";
            if (items[i].GroupTitle != null) {
                caption = items[i].GroupTitle();
            } else if (items[i].Caption != null) {
                caption = items[i].Caption();
            } else if (items[i].TabTitle != null) {
                caption = items[i].TabTitle();
            }
            this.containerClicked({ Item: items[i], Caption: caption, Color: color }, null);
            if (this.currentButtonMenu().length == 0) {
                if (items[i].Groups != null) {
                    this.initContextMenu(ko.utils.unwrapObservable(items[i].Groups), color, rekIndex + 1);
                } else if (items[i].Container != null) {
                    this.initContextMenu(ko.utils.unwrapObservable(items[i].Container), color, rekIndex + 1);
                }
            } else {
                break;
            }
        }
    }
    public permissionEnable = (value) => {
        const ActionKey = ko.toJS(value.ActionKey);
        const Enabled = ko.toJS(value.Enabled);
        let contextCol = this.contextCollection();
        if (value.Context != null) {
            contextCol = [value.Context];
        }
        ko.utils.arrayForEach(contextCol, (context) => {
            ko.utils.arrayForEach(context.Container(), (container) => {
                this._setMenuButtonEnable(ActionKey, Enabled, container);
            });
        });
    }
    public permissionVisible = (value) => {
        const ActionKey = ko.toJS(value.ActionKey);
        const Visible = ko.toJS(value.Visible);
        let contextCol = this.contextCollection();
        if (value.Context != null) {
            contextCol = [value.Context];
        }
        ko.utils.arrayForEach(contextCol, (context) => {
            ko.utils.arrayForEach(context.Container(), (container) => {
                this._setMenuButtonVisibility(ActionKey, Visible, container);
            });
        });
    }
    public checkHorizontalModelVisibility = () => {
        setTimeout(() => {
            if (this.horizontalMenuContainer() != null) {
                const userMenuVisible = this.userMenu().Visible();
                this.userMenu().Visible(false);
                this.horizontalMode($(this.horizontalMenuContainer()).height() <= $(this.horizontalMenuContainer()).parent().height() + 4);
                this.userMenu().Visible(userMenuVisible);
            }
            if (this._ignoreDocumentClick == false) {
                this.MenuVisible(false);
            }
            this._ignoreDocumentClick = false;
        }, 1);
    }
    public raiseEvent = (sender) => {
        for (let i = 0; i < this._events.length; i++) {
            this._events[i](sender);
        }
    }
    public dispose() {
    }
    private _setMenuButtonVisibility = (actionkey, visible, container) => {
        if (container.ActionKey() == actionkey) {
            container.Visible(visible);
            return;
        }
        ko.utils.arrayForEach(container.Container(), (subContainer) => {
            this._setMenuButtonVisibility(actionkey, visible, subContainer);
        });
        ko.utils.arrayForEach(container.Buttons(), (button: BaoMenuButton) => {
            if (ko.unwrap(button.ActionKey) == actionkey) {
                button.Visible(visible);
                return;
            }
        });
    }
    private _setMenuButtonEnable = (actionkey, enabled, container) => {
        if (container.ActionKey() == actionkey) {
            container.Enabled(enabled);
            return;
        }
        ko.utils.arrayForEach(container.Container(), (subContainer) => {
            this._setMenuButtonEnable(actionkey, enabled, subContainer);
        });
        ko.utils.arrayForEach(container.Buttons(), (button: BaoMenuButton) => {
            if (ko.unwrap(button.ActionKey) == actionkey) {
                button.Enabled(enabled);
                return;
            }
        });
    }

    notificationIconClick = () => {
        baoRouter.setHash("#UserTaggingOverview");
    }
    private registryUserOnTaggingsChangedHandler = () => {
        MessageBus.subscribe([this.taggingsChangedEventHandlers])
            .then(() => {
                return Bao.post('UserTagging/GetNotificationCount', JSON.stringify({ userId: Bao.Session.User.UserId() }))
                    .then((count: number) => this.notificationCount(count))
                    .fail(() => {
                        console.warn('Cannot connect to MessageBus');
                    });
            });

    }
}
export default new BaoApp();
